import { call, put, takeLatest } from 'redux-saga/effects';
import {
  bulkCreateContractSOV,
  createContract,
  createContractSOV,
  createEmptyContractSOV,
  deleteContract,
  deleteContractSOV,
  getContractDetail,
  getContractList,
  getContractList2,
  removeAllContractSOV,
  updateContract,
  updateContractMetaData,
  updateContractSOV,
} from '../../api/constlink';
import gHistory from '../../util/history';
import {
  bulkCreateContractSOVAsync,
  BULK_CREATE_CONTRACT_SOV,
  createContractAsync,
  createContractSOVAsync,
  createEmptyContractSOVAsync,
  CREATE_CONTRACT,
  CREATE_CONTRACT_SOV,
  CREATE_EMPTY_CONTRACT_SOV,
  deleteContractAsync,
  deleteContractSOVAsync,
  DELETE_CONTRACT,
  DELETE_CONTRACT_SOV,
  getContractDetailAsync,
  getContractListAsync,
  GET_CONTRACT_DETAIL,
  GET_CONTRACT_LIST,
  removeAllContractSOVAsync,
  REMOVE_ALL_CONTRACT_SOV,
  updateContractAsync,
  updateContractMetaDataAsync,
  updateContractSOVAsync,
  UPDATE_CONTRACT,
  UPDATE_CONTRACT_META_DATA,
  UPDATE_CONTRACT_SOV,
  getContractList2Async,
  GET_CONTRACT_LIST2,
} from './actions';

import { Contract, ContractSOV } from './types';

function* getContractListSaga(
  action: ReturnType<typeof getContractListAsync.request>,
) {
  try {
    const contracts: Contract[] = yield call(getContractList, action.payload);
    yield put(getContractListAsync.success(contracts));
  } catch (e: any) {
    yield put(getContractListAsync.failure(e));
  }
}

function* getContractList2Saga(
  action: ReturnType<typeof getContractList2Async.request>,
) {
  try {
    const contract: Contract = yield call(getContractList2, action.payload);
    yield put(getContractList2Async.success(contract));
  } catch (e: any) {
    yield put(getContractList2Async.failure(e));
  }
}

function* createContractSaga(
  action: ReturnType<typeof createContractAsync.request>,
) {
  try {
    const contract: Contract = yield call(createContract, action.payload);
    yield put(createContractAsync.success(contract));
    gHistory.goBack();
  } catch (e: any) {
    yield put(createContractAsync.failure(e));
  }
}

function* updateContractSaga(
  action: ReturnType<typeof updateContractAsync.request>,
) {
  try {
    const contract: Contract = yield call(updateContract, action.payload);
    yield put(updateContractAsync.success(contract));
  } catch (e: any) {
    yield put(updateContractAsync.failure(e));
  }
}

function* deleteContractSaga(
  action: ReturnType<typeof deleteContractAsync.request>,
) {
  try {
    const contractId: number = yield call(deleteContract, action.payload);
    yield put(deleteContractAsync.success(contractId));
  } catch (e: any) {
    yield put(deleteContractAsync.failure(e));
  }
}

function* getContractDetailSaga(
  action: ReturnType<typeof getContractDetailAsync.request>,
) {
  try {
    const contract: Contract = yield call(getContractDetail, action.payload);
    yield put(getContractDetailAsync.success(contract));
  } catch (e: any) {
    yield put(getContractDetailAsync.failure(e));
  }
}

function* createContractSOVSaga(
  action: ReturnType<typeof createContractSOVAsync.request>,
) {
  try {
    const contractSOV: ContractSOV = yield call(
      createContractSOV,
      action.payload,
    );
    yield put(createContractSOVAsync.success(contractSOV));
  } catch (e: any) {
    yield put(createContractSOVAsync.failure(e));
  }
}

function* updateContractSOVSaga(
  action: ReturnType<typeof updateContractSOVAsync.request>,
) {
  try {
    const contractSOV: ContractSOV = yield call(
      updateContractSOV,
      action.payload,
    );
    yield put(updateContractSOVAsync.success(contractSOV));
  } catch (e: any) {
    yield put(updateContractSOVAsync.failure(e));
  }
}

function* deleteContractSOVSaga(
  action: ReturnType<typeof deleteContractSOVAsync.request>,
) {
  try {
    const contractSOVId: number = yield call(deleteContractSOV, action.payload);
    yield put(deleteContractSOVAsync.success(contractSOVId));
  } catch (e: any) {
    yield put(deleteContractSOVAsync.failure(e));
  }
}

function* createEmptyContractSOVSaga(
  action: ReturnType<typeof createEmptyContractSOVAsync.request>,
) {
  try {
    const contractSOV: ContractSOV = yield call(
      createEmptyContractSOV,
      action.payload,
    );
    yield put(createEmptyContractSOVAsync.success(contractSOV));
  } catch (e: any) {
    yield put(createEmptyContractSOVAsync.failure(e));
  }
}

function* bulkCreateContractSOVSaga(
  action: ReturnType<typeof bulkCreateContractSOVAsync.request>,
) {
  try {
    const contract: Contract = yield call(
      bulkCreateContractSOV,
      action.payload,
    );
    yield put(bulkCreateContractSOVAsync.success(contract));
  } catch (e: any) {
    yield put(bulkCreateContractSOVAsync.failure(e));
  }
}

function* removeAllContractSOVSaga(
  action: ReturnType<typeof removeAllContractSOVAsync.request>,
) {
  try {
    const contract: Contract = yield call(removeAllContractSOV, action.payload);
    yield put(removeAllContractSOVAsync.success(contract));
  } catch (e: any) {
    yield put(removeAllContractSOVAsync.failure(e));
  }
}

function* updateContractMetaDataSaga(
  action: ReturnType<typeof updateContractMetaDataAsync.request>,
) {
  try {
    const contract: Contract = yield call(
      updateContractMetaData,
      action.payload,
    );
    yield put(updateContractMetaDataAsync.success(contract));
  } catch (e: any) {
    yield put(updateContractMetaDataAsync.failure(e));
  }
}

export function* contractsSaga() {
  yield takeLatest(GET_CONTRACT_LIST, getContractListSaga);
  yield takeLatest(GET_CONTRACT_LIST2, getContractList2Saga);
  yield takeLatest(CREATE_CONTRACT, createContractSaga);
  yield takeLatest(UPDATE_CONTRACT, updateContractSaga);
  yield takeLatest(DELETE_CONTRACT, deleteContractSaga);
  yield takeLatest(GET_CONTRACT_DETAIL, getContractDetailSaga);
  yield takeLatest(CREATE_CONTRACT_SOV, createContractSOVSaga);
  yield takeLatest(UPDATE_CONTRACT_SOV, updateContractSOVSaga);
  yield takeLatest(DELETE_CONTRACT_SOV, deleteContractSOVSaga);
  yield takeLatest(CREATE_EMPTY_CONTRACT_SOV, createEmptyContractSOVSaga);
  yield takeLatest(BULK_CREATE_CONTRACT_SOV, bulkCreateContractSOVSaga);
  yield takeLatest(REMOVE_ALL_CONTRACT_SOV, removeAllContractSOVSaga);
  yield takeLatest(UPDATE_CONTRACT_META_DATA, updateContractMetaDataSaga);
}
